export class TransmissionType{
  public static value(): string[] {
    return ['Механіка', 'Автомат'];
  }
}
